<div class="dialog-export-progress">
  <header class="dialog-export-progress__header">
    <h2 class="dialog-export-progress__title">
      {{ 'exportProgress.dialog.title' | translate }}
    </h2>
  </header>

  <main class="dialog-export-progress__body">
    <p class="dialog-export-progress__description">
      {{ 'exportProgress.dialog.description' | translate }}
    </p>
    <mat-progress-bar mode="determinate" [value]="progress" color="primary" />
    <span class="dialog-export-progress__percent">{{ progress }}%</span>
  </main>

  <footer class="dialog-export-progress__footer">
    <ui-atom-button
      styling="outlined"
      [withShadow]="false"
      [text]="'exportProgress.dialog.cancel' | translate"
      (buttonClick)="onCancel()"
    />
  </footer>
</div>
